/* cart-xilugs.js — 03/10/2026 (chu shop duyet). Ba viec nho cho gio hang, khong dung thu vien:
   1) <cart-goi-y>: the "You may also like" — goi Product Recommendations (intent=related) theo sp DAU TIEN trong gio,
      ve qua sections/cart-goi-y.liquid (da loc: chi Watch Strap, bo builder, bo sp trong gio). Cat con data-limit the.
      Ngan keo / trang gio ve lai phan tu nay moi khi gio doi -> connectedCallback chay lai -> goi y tai lai.
      Khong co goi y (hoac loi mang) -> giu an. PC co chuot: mui ten ‹ ›, keo chuot, lan chuot -> cuon ngang 1 hang the.
   2) Thanh dinh day trang /cart (mobile): AN khi khoi Order Summary (.cart-tong) dang hien tren man hinh — gan lop
      "cart-tong-thay" len <html>, CSS o component-cart-items.css.
   3) So mon canh "Your Cart" ([data-cart-dem]) cap nhat theo su kien cartUpdate cua Dawn (pubsub.js). */
if (!customElements.get('cart-goi-y')) {
  customElements.define(
    'cart-goi-y',
    class CartGoiY extends HTMLElement {
      connectedCallback() {
        const id = this.dataset.productId;
        const ds = this.querySelector('.cgy__list');
        if (!id || !ds) return;
        const goc = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const url = `${goc}recommendations/products?product_id=${encodeURIComponent(id)}&limit=10&intent=related&section_id=cart-goi-y`;
        const soThe = parseInt(this.dataset.limit, 10) || 6;
        fetch(url)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            if (!this.isConnected || !html) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const the = [...doc.querySelectorAll('.cgy__the')].slice(0, soThe);
            if (!the.length) return;
            ds.replaceChildren(...the);
            this.hidden = false;
            this.catTen();
            this.ganDieuKhien(ds);
          })
          .catch(() => {});
      }

      /* Ten sp: 2 dong, "…" o CUOI dong 2 — bo bot tu cuoi (va dau "-" treo) toi khi vua 2 dong. Ten day du o title. */
      catTen() {
        this.querySelectorAll('.cgy__ten').forEach((el) => {
          const goc = el.textContent.trim();
          el.title = goc;
          if (el.scrollHeight <= el.clientHeight + 1) return;
          const tu = goc.split(/\s+/);
          el.classList.add('cgy__ten--cat');
          while (tu.length > 1) {
            tu.pop();
            el.textContent = tu.join(' ').replace(/[\s\-–—,·&|]+$/, '') + '…';
            if (el.scrollHeight <= el.clientHeight + 1) break;
          }
        });
      }

      /* PC (co chuot): mui ten ‹ › cuon dung 1 the; keo chuot; lan chuot doc -> cuon ngang. Mobile: chi vuot (CSS). */
      ganDieuKhien(ds) {
        const lui = this.querySelector('.cgy__lui');
        const toi = this.querySelector('.cgy__toi');
        const buoc = () => {
          const t = ds.querySelector('.cgy__the');
          if (!t) return ds.clientWidth;
          const gap = parseFloat(getComputedStyle(ds).columnGap) || 0;
          return t.getBoundingClientRect().width + gap;
        };
        const capNhat = () => {
          const max = ds.scrollWidth - ds.clientWidth - 1;
          if (lui) lui.disabled = ds.scrollLeft <= 1;
          if (toi) toi.disabled = ds.scrollLeft >= max;
        };
        if (lui) lui.addEventListener('click', () => ds.scrollBy({ left: -buoc(), behavior: 'smooth' }));
        if (toi) toi.addEventListener('click', () => ds.scrollBy({ left: buoc(), behavior: 'smooth' }));
        ds.addEventListener('scroll', capNhat, { passive: true });
        capNhat();

        /* lan chuot doc khi tro vao hang the -> cuon ngang (chi khi con cho de cuon theo huong do) */
        ds.addEventListener(
          'wheel',
          (e) => {
            if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
            const max = ds.scrollWidth - ds.clientWidth;
            if ((e.deltaY < 0 && ds.scrollLeft <= 0) || (e.deltaY > 0 && ds.scrollLeft >= max - 1)) return;
            e.preventDefault();
            ds.scrollLeft += e.deltaY;
          },
          { passive: false }
        );

        /* keo bang chuot: tat snap trong luc keo, bat lai khi tha (trinh duyet tu snap vao the gan nhat) */
        let dang = false, x0 = 0, s0 = 0, daKeo = false;
        ds.addEventListener('pointerdown', (e) => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          dang = true; daKeo = false; x0 = e.clientX; s0 = ds.scrollLeft;
        });
        window.addEventListener('pointermove', (e) => {
          if (!dang) return;
          const dx = e.clientX - x0;
          if (!daKeo && Math.abs(dx) > 5) { daKeo = true; ds.classList.add('is-keo'); }
          if (daKeo) { ds.scrollLeft = s0 - dx; e.preventDefault(); }
        });
        window.addEventListener('pointerup', () => {
          if (!dang) return;
          dang = false;
          if (daKeo) {
            ds.classList.remove('is-keo');
            const b = buoc();
            ds.scrollTo({ left: Math.round(ds.scrollLeft / b) * b, behavior: 'smooth' });
          }
        });
        /* vua keo xong thi khong mo link */
        ds.addEventListener('click', (e) => { if (daKeo) { e.preventDefault(); e.stopPropagation(); daKeo = false; } }, true);
        ds.addEventListener('dragstart', (e) => e.preventDefault());
      }
    }
  );
}

(function () {
  if (window.__cartTongQuanSat) return;
  window.__cartTongQuanSat = true;
  function batDau() {
    const tong = document.querySelector('.cart-tong');
    if (!tong || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(
      (muc) => {
        document.documentElement.classList.toggle('cart-tong-thay', muc.some((m) => m.isIntersecting));
      },
      { threshold: 0 }
    ).observe(tong);
  }
  function demMon() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      /* 13/10 (26b): chi dem dong CHA — dong con (phu phi ADDON, co parent_relationship) khong cong */
      const cd = e && e.cartData; let n = cd && cd.item_count;
      if (cd && Array.isArray(cd.items) && cd.items.length) {
        n = cd.items.reduce((t, i) => t + ((i.parent_relationship && (i.parent_relationship.parent_key || i.parent_relationship.parent)) ? 0 : (Number(i.quantity) || 0)), 0);
      }
      if (typeof n !== 'number') return;
      document.querySelectorAll('[data-cart-dem]').forEach((el) => {
        el.textContent = n + (n === 1 ? ' item' : ' items');
      });
    });
  }
  function khoi() {
    batDau();
    demMon();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', khoi);
  else khoi();
})();
